import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import corner1 from 'assets/img/illustrations/corner-1.png';
import corner2 from 'assets/img/illustrations/corner-4.png';
import Background from 'components/common/Background';
import IconAlert from 'components/common/IconAlert';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { FaArrowRight, FaExclamationTriangle } from 'react-icons/fa';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import { useToast } from 'context/providers/ToastProvider';


const CuentasPorPagarWarning = ({
    idUsuario,
    setShowModalOrdenesVencidas
}) => {

    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();
    const [cargando, setCargando] = useState(true);
    const [deuda, setDeuda] = useState({});

    const ObtenerTotalCuentasPorCobrar = async (idUsuario) => {
        setCargando(true);
        const response = await fetch("/api/home/ObtenerTotalCuentasPorCobrar/?idUsuario=" + idUsuario, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error.message);

            });

        if (response.ok) {
            console.log(response);
            const data = await response.json();
            if (data['table1'][0].iResponseType == 1) {
                setDeuda(data['table2'][0]);
            }
            else {
                showErrorToast(data['table1'][0].vMessage);
            }


        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setCargando(false);

    };

    useEffect(() => {
        ObtenerTotalCuentasPorCobrar(idUsuario);
    }, [idUsuario]);

    return (
        cargando ? <Skeleton /> :
            <Card className={`overflow-hidden`}>
                {(deuda.dDeudaUSD > 0 || deuda.dDeudaMXN > 0) ?
                    <Background image={corner1} className="p-x1 bg-card" />
                    : <Background image={corner2} className="p-x1 bg-card" />}

                <Card.Body className="position-relative">

                    {(deuda.dDeudaUSD > 0 || deuda.dDeudaMXN > 0) && <>
                        <h5 className="text-warning">  <FaExclamationTriangle className="me-2" /> Accounts receivable</h5>

                        <h5 className="text-danger pt-3">
                            ${parseFloat(deuda.dDeudaMXN).toLocaleString("es-MX", {
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2
                            })} MXN <span className="text-primary fs--1">  <FaArrowRight className="me-2" /> [{deuda.nOrdenesMXN} orders]</span></h5>

                        <h5 className="text-danger">${parseFloat(deuda.dDeudaUSD).toLocaleString("es-MX", {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2
                        })} USD <span className="text-primary fs--1">  <FaArrowRight className="me-2" /> [{deuda.nOrdenesUSD} orders]</span></h5>

                        <Button
                            as={Link}
                            variant="link"
                            className="fs--1 text-warning ps-0"
                            onClick={() => { setShowModalOrdenesVencidas(true) }}
                        >
                            Display Unpaid Orders
                            <FontAwesomeIcon icon="chevron-right" className="ms-1 fs--2" />
                        </Button>
                    </>
                    }

                    {(deuda.dDeudaUSD == 0 && deuda.dDeudaMXN == 0) &&
                    <IconAlert className="mb-0" variant={'success'} >
                        <p className="mb-0">Everything is Ok!</p>
                    </IconAlert>
                    }
                </Card.Body>
            </Card>
    );
};

CuentasPorPagarWarning.propTypes = {
    idUsuario: PropTypes.number,
    setShowModalOrdenesVencidas: PropTypes.func,
};

export default CuentasPorPagarWarning;
